import {Deserializable} from '../deserializable';
import {CalendarNewsExtraFile} from './calendarnewsextrafile';

export  class CalendarNewsExtra implements Deserializable
{
  public  id: number;
  public  weekId: number;
  public  yearId: number;
  public  noiDung: string;
  public  staffId: number;
  public  created: Date;
  public calendarNewsExtraFiles: CalendarNewsExtraFile[];

  deserialize(input: any): this {
    Object.assign(this, input);
    this.calendarNewsExtraFiles = input.calendarNewsExtraFiles!=null ?  input.calendarNewsExtraFiles.map(calendarNewsExtraFiles => new CalendarNewsExtraFile().deserialize(calendarNewsExtraFiles)) : [];
    return this;
  }
}
